/**
 * Zbalenie tabuľky dielcov si pamätá prehliadač (KOLO 193).
 *
 * User: *„keď vyjdem zo zákazky, nech si pamätá, či som mal rozbalené
 * všetko alebo zbalené — nech si u užívateľa pamätá, ako to mal"* a
 * *„v prehliadači, ale nech začne vždy zbalená"*. Kľúč je používateľ +
 * varianta; bez uloženého stavu je všetko zbalené. Úložisko môže chýbať
 * (súkromné okno, plné), vtedy sa nič nepamätá a tabuľka začne zbalená.
 */

export interface StavZbalenia {
  /** Zbalené zostavy (id). Nová zostava v zozname nie je — je rozbalená. */
  zbalene: string[];
  /** Rozbalené dielce s vrstvami alebo operáciami (id). */
  rozbalene: string[];
}

export function klucZbalenia(pouzivatel: string, variantaId: string): string {
  return `tandem_zbalenie_${pouzivatel}_${variantaId}`;
}

function zoznamId(hodnota: unknown): string[] | null {
  return Array.isArray(hodnota) && hodnota.every((x) => typeof x === "string")
    ? hodnota
    : null;
}

export function nacitajZbalenie(kluc: string): StavZbalenia | null {
  try {
    const text = localStorage.getItem(kluc);
    if (!text) return null;
    const data = JSON.parse(text) as Record<string, unknown>;
    const zbalene = zoznamId(data.zbalene);
    const rozbalene = zoznamId(data.rozbalene);
    return zbalene && rozbalene ? { zbalene, rozbalene } : null;
  } catch {
    return null;
  }
}

export function ulozZbalenie(kluc: string, stav: StavZbalenia): void {
  try {
    localStorage.setItem(kluc, JSON.stringify(stav));
  } catch {
    // súkromné okno / plné úložisko — stav sa jednoducho nezapamätá
  }
}
